<div class="modal fade modal--mini" id="question-add-note__modal" tabindex="-1" role="dialog" aria-labelledby="add-a-note-modal-title" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">

      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4 id="add-a-note-modal-title">Add a note</h4>        
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          <!-- <h3 class="mb-30">Is there anything you'd like to add?</h3> -->

          <div class="form-group">       
            <textarea placeholder="Start typing…" rows="7" [(ngModel)]="note" (ngModelChange)="onChange()" class="form-control"></textarea>
          </div>

          <!--<div class="form-group mb-30">
            <label class="mb-15">Upload files (optional)</label>
            <div class="note note&#45;&#45;sm note&#45;&#45;info mb-15 mb-md-20">
              <div class="note__icon">
                <svg class="icon"><use xlink:href="#info-small"></use></svg>
              </div>
              <div class="note__content">
                <p>Note on what to take images of lorem ipsum dolor sit amet.</p>
              </div>
            </div>
            <div class="custom-upload custom-upload&#45;&#45;media dz-clickable" [id]="fileSelectorEl">
              <div class="custom-upload__dropzone dz-default">
                <div class="custom-upload__thumb">
                  <img src="/assets/img/upload.svg" alt="">
                </div>
                <div class="custom-upload__instructions">
                  <p>Tap to add files</p>
                  <svg class="icon"><use xlink:href="#upload"></use></svg>
                  <p>Drag &amp; drop files here or <strong>browse</strong></p>
                </div>
              </div>
            </div>
          </div>-->

          <!--       
          <div class="mt-20">
            <a href="javascript:void(0);" class="link link--sm text-color-error" (click)="deleteNote()">
              <svg class="icon">
                  <use xlink:href="#trash-bin"></use>
              </svg>
              <span>Delete note</span>
            </a>
          </div> -->

        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="#" class="button button--secondary" data-dismiss="modal">Cancel</a>
          <a href="javascript:void(0);" [attr.disabled]="buttonDisabled ? true : null" class="button button--primary" (click)="save()">Add</a>
        </div>
      </div>
    </div>
  </div>
</div>
